import { IdentityProvider } from '~/shared/services/userService';

const LABELS: Record<IdentityProvider, string> = {
  google: 'Google',
  apple: 'Apple',
};

/** Human-readable provider name for toasts ("Google", "Apple"). */
const providerLabel = (provider: IdentityProvider): string => LABELS[provider];

export default providerLabel;
